import { z } from "zod/v4";

import { AnalyticsViewTypeList } from "../schemas/analytics/base";

import { EstimatedTestLengthRangeSchema } from "./experience-analysis";

export const ExperienceAnalytics = z.object({
  progress: z.number().nullish(),
  analysisUrl: z.string().nullish(),
  controlMonthly: z.number().nullish(),
  excludeFromImpact: z.boolean().default(false).optional(),
  impact: z.number().nullish(),
  analyticsViewType: z.enum(AnalyticsViewTypeList).default("none").optional(),
  estimatedTestLengthRange: EstimatedTestLengthRangeSchema.default({
    low: null,
    high: null,
  }).optional(),
  impactMetric: z.string().nullish(),
  visitors: z.number().optional(),
  orders: z.number().optional(),
});
